import { queryOptions } from '@tanstack/react-query';

import { TWENTY_FOUR_H_IN_MS } from 'ae-constants/constants';

import { useCapabilityApi } from '../use-capability-api';

import { getCapabilitiesQueryKey } from './capabilities';

export const useCapabilitiesOptions = (orgID: string) => {
  const api = useCapabilityApi();

  return queryOptions({
    queryFn: async () => {
      try {
        const data = await api.getUserJWTCapabilitiesByOrganization({
          orgID,
        });

        return data;
      } catch {
        // The api endpoint sometimes returns null instead of [],
        // but null is not included in the openapi return type
        return [];
      }
    },
    queryKey: getCapabilitiesQueryKey(orgID),
    gcTime: TWENTY_FOUR_H_IN_MS,
  });
};
